import { MARKETPLACE_PLATFORMS } from './platforms';

/**
 * Cifra roșie din bara laterală: comenzile care așteaptă factură, pe pagina fiecărei platforme
 * (`/comenzi-emag` → 2). Doar platformele conectate (celelalte nu au rând în meniu) și doar
 * numerele pozitive.
 */
export function uninvoicedNavCounts(
  counts: Record<string, number> | undefined,
  connected: ReadonlySet<string>,
): Record<string, number> {
  const out: Record<string, number> = {};
  for (const [code, n] of Object.entries(counts ?? {})) {
    const path = MARKETPLACE_PLATFORMS[code]?.pagePath;
    if (path && connected.has(code) && n > 0) out[path] = n;
  }
  return out;
}

/** Cifra afișată: peste 99 nu mai încape în bulină. */
export function navCountLabel(n: number): string {
  return n > 99 ? '99+' : String(n);
}

/** „1 comandă nefacturată”, „2 comenzi nefacturate”, „20 de comenzi nefacturate”. */
export function uninvoicedOrdersText(n: number): string {
  if (n === 1) return '1 comandă nefacturată';
  const rest = n % 100;
  const de = n >= 20 && (rest === 0 || rest >= 20) ? 'de ' : '';
  return `${n} ${de}comenzi nefacturate`;
}
